import { render, staticRenderFns } from "./IconCrown.vue?vue&type=template&id=12eff47c&scoped=true"
import script from "./IconCrown.vue?vue&type=script&lang=js"
export * from "./IconCrown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12eff47c",
  null
  
)

export default component.exports